import React, { ReactElement, useContext } from 'react';
import { FindAndReplace } from '../types';
import Typography from '../../../../../kingpin/atoms/Typography';
import { useGetMetric } from '../../../../GoalShow/useGoalData';
import ListItem from '../../../DatasetDefinitions/DatasetsIndex/PerformanceDatasetWizard/ListItem';
import ColDiv from '../../../DatasetDefinitions/DatasetsIndex/PerformanceDatasetWizard/MetricsStep/ColDiv';
import moment from 'moment';
import { Link } from 'react-router-dom';
import getUsageCount from '../FindAndReplace/useFindAndReplace/getUsageCount';
import ContextMenu, { Option } from '../../../../../kingpin/atoms/ContextMenu';
import usePopup from '../../../../../hooks/usePopup';
import ReceiptDetails from './ReceiptDetails';
import { PortalsContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import { getMetricLink } from '../../../AllSets/routes';
import { ArrowCol, COLUMN_FLEX, MenuCol } from './columns';

const LINK_STYLE = { display: 'flex', minWidth: 0, maxWidth: '100%' };

const FindAndReplaceHistoryReceipt = ({
  receipt,
}: {
  receipt: FindAndReplace.EnrichedMetricReceipt;
}): ReactElement | null => {
  const {
    isOpen: isReceiptItemOpen,
    open: openReceiptItem,
    close: closeReceiptItem,
  } = usePopup();
  const { selectedPortal } = useContext(PortalsContext);
  const metricLookup = useGetMetric();
  const findMetric = metricLookup(receipt.findMetricId);
  const replaceMetric = metricLookup(receipt.replaceMetricId);
  if (!findMetric || !replaceMetric) {
    return null;
  }
  return (
    <>
      <ListItem>
        <ColDiv flex={COLUMN_FLEX.date}>
          <Typography.Body type="Label" isEllipsis>
            {moment(receipt.createdOn).format('DD/MM/YY HH:mm')}
          </Typography.Body>
        </ColDiv>
        <ColDiv flex={COLUMN_FLEX.findMetric}>
          <Link
            to={getMetricLink({ metric: findMetric, portal: selectedPortal })}
            target="_blank"
            data-testid={`original-metric-link-${findMetric.id}`}
            style={LINK_STYLE}
          >
            <Typography.Body
              data-testid={`original-metric-${findMetric.id}`}
              type="Body 13"
              isEllipsis
              isLink
            >
              {findMetric.name}
            </Typography.Body>
          </Link>
        </ColDiv>
        <ArrowCol />
        <ColDiv flex={COLUMN_FLEX.replaceMetric}>
          <Link
            to={getMetricLink({
              metric: replaceMetric,
              portal: selectedPortal,
            })}
            target="_blank"
            style={LINK_STYLE}
          >
            <Typography.Body
              data-testid={`replace-metric-${replaceMetric.id}`}
              type="Body 13"
              isEllipsis
              isLink
            >
              {replaceMetric.name}
            </Typography.Body>
          </Link>
        </ColDiv>
        <ColDiv flex={COLUMN_FLEX.itemsAffected}>
          <Typography.Body type="Body 13" isEllipsis>
            {getUsageCount(receipt.affectedContentIds)}
          </Typography.Body>
        </ColDiv>
        <MenuCol>
          <ContextMenu
            testId={'find-replace-history-context-menu'}
            buttonType="Secondary"
          >
            <Option onClick={openReceiptItem} label="Show Details"></Option>
          </ContextMenu>
        </MenuCol>
      </ListItem>
      <ReceiptDetails
        isOpen={isReceiptItemOpen}
        close={closeReceiptItem}
        receipt={receipt}
      />
    </>
  );
};

export default FindAndReplaceHistoryReceipt;
